import { pattern } from "./pattern"

export const postCodeValidator = (value) => {
    const postCodeRegex = new RegExp(pattern.postCode);
    if (value.length > 7) return { valid: false, error: "Maximum 7 characters allowed" }
    if (postCodeRegex.test(value)) return { valid: true, error: false };
    else return { valid: false, error: "Allowed characters a-z A-Z 0-9" };
}